import Stack from "@mui/material/Stack";

export const StageBottomContent = ({ children }: any) => {
  return (
    <Stack paddingX={6} paddingY={10} gap={12} direction="row" flexWrap="wrap" sx={{background: "#FFFFFF", borderBottomLeftRadius: {xs: 0, sm: 8}, borderBottomRightRadius: {xs: 0, sm: 8}}} >
      {children}
    </Stack>
  );
};
